/**
 * NuveRise — Recently Viewed (client-side, localStorage-backed)
 *
 * Storage: localStorage key 'nuveRecentlyViewed' — array of:
 *   { handle, title, image, price, url, viewedAt }
 * Cap: 6 newest, oldest evicted.
 *
 * DOM contract:
 *   [data-current-product] — emitted by main-product.liquid; supplies the
 *     handle + meta for the page's current product. Hidden div.
 *   [data-recently-viewed] — the <aside> wrapper rendered by recently-viewed.liquid.
 *   [data-recently-viewed-row] — the grid <div> populated by this script.
 *
 * Renders up to 4 items (excluding the current product on a product page).
 */
(function () {
  'use strict';

  var KEY = 'nuveRecentlyViewed';
  var MAX = 6;
  var RENDER_LIMIT = 4;

  function get() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function set(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX)));
    } catch (e) {
      // Storage unavailable — fail silent.
    }
  }

  function record(item) {
    if (!item || !item.handle) return;
    var items = get().filter(function (i) { return i.handle !== item.handle; });
    items.unshift({
      handle: item.handle,
      title: item.title || '',
      image: item.image || '',
      price: item.price || '',
      url: item.url || '#',
      viewedAt: Date.now()
    });
    set(items);
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function render(excludeHandle) {
    var container = document.querySelector('[data-recently-viewed]');
    if (!container) return;
    var row = container.querySelector('[data-recently-viewed-row]');
    if (!row) return;

    var items = get()
      .filter(function (i) { return !excludeHandle || i.handle !== excludeHandle; })
      .slice(0, RENDER_LIMIT);

    if (items.length === 0) {
      container.hidden = true;
      row.innerHTML = '';
      return;
    }

    container.hidden = false;
    row.innerHTML = items.map(function (i) {
      var title = escapeHtml(i.title);
      var price = escapeHtml(i.price);
      var url = escapeHtml(i.url);
      var image = escapeHtml(i.image);
      return (
        '<a href="' + url + '" class="rv-card" aria-label="' + title + '">' +
          (image
            ? '<div class="rv-card__frame"><img src="' + image + '" alt="' + title + '" width="240" height="240" loading="lazy" onerror="this.style.display=\'none\';this.parentNode.classList.add(\'rv-card__frame--empty\')"></div>'
            : '<div class="rv-card__frame rv-card__frame--empty" aria-hidden="true"></div>') +
          '<h4 class="rv-card__title">' + title + '</h4>' +
          (price ? '<p class="rv-card__price">' + price + '</p>' : '') +
        '</a>'
      );
    }).join('');
  }

  function init() {
    var meta = document.querySelector('[data-current-product]');
    if (meta) {
      record({
        handle: meta.getAttribute('data-handle'),
        title: meta.getAttribute('data-title'),
        image: meta.getAttribute('data-image'),
        price: meta.getAttribute('data-price'),
        url: meta.getAttribute('data-url')
      });
      render(meta.getAttribute('data-handle'));
    } else {
      render(null);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.NuveRecentlyViewed = {
    get: get,
    record: record,
    render: render,
    clear: function () { set([]); render(null); }
  };
})();
